import React, { useState } from 'react';
import api from '../../services/api';

const SubscribeForm = ({
  source = 'homepage',
  variant = 'light',
  className = '',
}) => {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');

    const trimmedPhone = phone.trim();
    if (!trimmedPhone) {
      setError('Please enter your WhatsApp number.');
      return;
    }

    try {
      setLoading(true);
      const response = await api.publicAPI.subscribeWhatsApp(trimmedPhone, source);
      if (response.data?.success) {
        setMessage(response.data.message || 'Thanks for subscribing!');
        setPhone('');
      } else {
        setError(response.data?.error || 'Could not subscribe. Please try again.');
      }
    } catch (submitError) {
      setError(api.utils.handleError(submitError));
    } finally {
      setLoading(false);
    }
  };

  const isDark = variant === 'dark';

  return (
    <form className={className} onSubmit={handleSubmit}>
      <div className={`flex ${isDark ? '' : 'bg-white border border-black'}`}>
        <input
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          placeholder="Enter your WhatsApp Number"
          value={phone}
          onChange={(event) => setPhone(event.target.value.replace(/[^\d+\s-]/g, ''))}
          maxLength={14}
          disabled={loading}
          className={
            isDark
              ? 'flex-1 px-3 py-2 bg-gray-800 text-white rounded-l-md focus:outline-none focus:ring-2 focus:ring-white'
              : 'flex-1 px-4 py-2 text-sm outline-none text-black'
          }
        />
        <button
          type="submit"
          disabled={loading}
          className={
            isDark
              ? 'bg-white text-black px-4 py-2 rounded-r-md font-semibold hover:bg-gray-200 transition-colors disabled:opacity-60'
              : 'bg-black text-white px-5 py-2 text-sm font-semibold disabled:opacity-60'
          }
        >
          {loading ? 'Saving...' : 'Subscribe'}
        </button>
      </div>
      {message && (
        <p className={`mt-2 text-sm ${isDark ? 'text-gray-300' : 'text-black'}`}>{message}</p>
      )}
      {error && (
        <p className={`mt-2 text-sm ${isDark ? 'text-red-300' : 'text-red-900'}`}>{error}</p>
      )}
    </form>
  );
};

export default SubscribeForm;
